import React from 'react'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'

const IconError = (): any => {
  return <ErrorOutlineIcon color='error' className='onerem' style={{ fill: 'red', fontSize: '20px' }} />
}

export default IconError
